export class MultipleStatutesParams {
  description: string;
  ordreAffichage: number;
  color: string;
  notUsed: boolean;
  defaultEntrant?: boolean;
  defaultSortant?: boolean;
  visionArbre?: string;
  cocherAjouterDroitAccesGroupeID: number;
  courrierActionDroitCocherGroupeID: number;
  courrierActionDroitDecocherGroupeID: number;
  servicesAuthorized: number[];
}

export class MultipleStatutesDTO {
  id: number;
  description: string;
  ordreAffichage: number;
  color: string;
  notUsed: boolean;
  defaultEntrant: boolean;
  defaultSortant: boolean;
  visionArbre: string;
  cocherAjouterDroitAccesGroupeID: number;
  courrierActionDroitCocherGroupeID: number;
  courrierActionDroitDecocherGroupeID: number;
  servicesAuthorized: number[];
}

export class MultipleStatutes {
  label: string;
  value: number;
  color: string;
  textColor: string;
  notUsed: boolean;
  cocherAjouterDroitAccesGroupeID: number;
  courrierActionDroitCocherGroupeID: number;
  courrierActionDroitDecocherGroupeID: number;
  ordreAffichage: number;
  servicesAuthorized: number[];
  isNewlyCreated?: boolean;
}

export class MailMultipleStatutesDTO {
  id: number;
  mailId: number;
  statusId: number;
  description: string;
  creationDate: string;
  color: string;
}

export class MailMultipleStatutes {
  id: number;
  mailId: number;
  statusId: number;
  description: string;
  creationDate: string;
  color: string;
  textColor: string;
  courrierActionDroitDecocherGroupeID?: number;
}
